const createBreadcrumbs = (data) =>
  data.map((b, i) => ({
    key: i,
    href: b.href,
    content: b.text,
    active: !!b.active
  }))

export { createBreadcrumbs }
